import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "@/views/Dashboard.vue";
//import Tables from "@/views/Tables.vue";
//import Billing from "@/views/Billing.vue";
//import VirtualReality from "@/views/VirtualReality.vue";
//import ProfileTemplate from "../views/ProfileTemplate.vue";
//import Rtl from "@/views/Rtl.vue";
//import SignIn from "@/views/SignIn.vue";
//import SignUp from "@/views/SignUp.vue";
import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import SendEmail from "../views/SendEmail.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Profile from "@/views/Profile.vue";
import Tipsters from "../views/Tipsters.vue";
import Usuarios from "../views/Usuarios.vue";
import Productos from "../views/Productos.vue";
import Descuentos from "../views/Descuentos.vue";
import Pedidos from "../views/Pedidos.vue";
import Configuracion from "../views/Configuracion.vue";
import PaisesVenta from "../views/PaisesVenta.vue";
import Canales from "../views/Canales.vue";
import Campanas from "../views/Campanas.vue";
import CampanasServicios from "../views/CampanasServicios.vue";
import PublicidadMeta from "../views/PublicidadMeta.vue";
import PersonalizacionTipster from "../views/PersonalizacionTipster.vue";
import CampanasTipster from "../views/CampanasTipster.vue";
import Landings from "../views/Landings.vue";
import AsignacionTipsters from "../views/AsignacionTipsters.vue";
import PanelPublicista from "../views/PanelPublicista.vue";
import PanelCliente from "../views/PanelCliente.vue";
import GrupoTelegram from "../views/GrupoTelegram.vue";
import Pronostico from "../views/Pronostico.vue";
import store from "/src/store";
import guest from "../middlewares/guest.js";
import auth from "../middlewares/auth.js";
import PanelTipster from "../views/PanelTipster.vue";
import SuscripcionesListaTipster from "../views/SuscripcionesListaTipster.vue";
import AnalyticsParticipantes from "../views/AnalyticsParticipantes.vue";
import AnalisisVentas from "../views/AnalisisVentas.vue";
import Roles from "../views/Roles.vue";
import Devoluciones from "../views/Devoluciones.vue";
import Pasarelas from "../views/Pasarelas.vue";
import PasarelaPublica from "../views/PasarelaPublica.vue";
import ResolverEnlace from "../views/ResolverEnlace.vue";
import PagoResultado from "../views/PagoResultado.vue";

function middlewarePipeline(context, middleware, index) {
  const nextMiddleware = middleware[index];
  if (!nextMiddleware) return context.next;

  return () => {
    const nextPipeline = middlewarePipeline(context, middleware, index + 1);
    nextMiddleware({ ...context, next: nextPipeline });
  };
}

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "HomeRedirect",
    component: () => import("@/views/Blank.vue"),
    meta: { middleware: [auth] },
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { middleware: [auth] },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { middleware: [guest] },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { middleware: [guest] },
  },
  {
    path: "/password/email",
    name: "SendEmail",
    component: SendEmail,
    meta: { middleware: [guest] },
  },
  {
    path: "/password/reset",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { middleware: [guest] },
  },

  {
    path: "/pronostico/:tipsterSlug/:productoSlug",
    name: "ResolverEnlace",
    component: ResolverEnlace,
    props: true,
  },
  {
    path: "/pronostico/:uuid",
    name: "Pronostico",
    component: Pronostico,
    props: true,
  },
  {
    path: "/pago/resultado",
    name: "PagoResultado",
    component: PagoResultado,
  },

  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { middleware: [auth] },
  },
  {
    path: "/tipsters",
    name: "Tipsters",
    component: Tipsters,
    meta: { middleware: [auth] },
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    component: Usuarios,
    meta: { middleware: [auth] },
  },
  {
    path: "/asignacion-tipsters",
    name: "AsignacionTipsters",
    component: AsignacionTipsters,
    meta: { middleware: [auth] },
  },
  {
    path: "/publicista/panel",
    name: "PanelPublicista",
    component: PanelPublicista,
    meta: { middleware: [auth] },
  },
  {
    path: "/tipster/panel",
    name: "PanelTipster",
    component: PanelTipster,
    meta: { middleware: [auth] },
  },
  {
    path: "/tipster/suscripciones",
    name: "SuscripcionesListaTipster",
    component: SuscripcionesListaTipster,
    meta: { middleware: [auth] },
  },
  {
    path: "/cliente/panel",
    name: "PanelCliente",
    component: PanelCliente,
    meta: { middleware: [auth] },
  },
  {
    path: "/productos",
    name: "Productos",
    component: Productos,
    meta: { middleware: [auth] },
  },
  {
    path: "/descuentos",
    name: "Descuentos",
    component: Descuentos,
    meta: { middleware: [auth] },
  },
  {
    path: "/analytics/participantes",
    name: "AnalyticsParticipantes",
    component: AnalyticsParticipantes,
    meta: { middleware: [auth] },
  },
  {
    path: "/analytics/ventas",
    name: "AnalisisVentas",
    component: AnalisisVentas,
    meta: { middleware: [auth] },
  },
  {
    path: "/pedidos",
    name: "Pedidos",
    component: Pedidos,
    meta: { middleware: [auth] },
  },
  {
    path: "/devoluciones",
    name: "Devoluciones",
    component: Devoluciones,
    meta: { middleware: [auth] },
  },
  {
    path: "/configuracion",
    name: "Configuracion",
    component: Configuracion,
    meta: { middleware: [auth] },
  },
  {
    path: "/paises-venta",
    name: "PaisesVenta",
    component: PaisesVenta,
    meta: { middleware: [auth] },
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { middleware: [auth] },
  },
  {
    path: "/canales",
    name: "Canales",
    component: Canales,
    meta: { middleware: [auth] },
  },
  {
    path: "/campanas",
    name: "Campanas",
    component: Campanas,
    meta: { middleware: [auth] },
  },
  {
    path: "/campanas-servicios",
    name: "CampanasServicios",
    component: CampanasServicios,
    meta: { middleware: [auth] },
  },
  {
    path: "/publicidad-meta",
    name: "PublicidadMeta",
    component: PublicidadMeta,
    meta: { middleware: [auth] },
  },
  {
    path: "/personalizacion-tipster",
    name: "PersonalizacionTipster",
    component: PersonalizacionTipster,
    meta: { middleware: [auth] },
  },
  {
    path: "/tipster/campanas",
    name: "CampanasTipster",
    component: CampanasTipster,
    meta: { middleware: [auth] },
  },
  {
    path: "/landings",
    name: "Landings",
    component: Landings,
    meta: { middleware: [auth] },
  },
  {
    path: "/grupo-telegram/:idCanal",
    name: "GrupoTelegram",
    component: GrupoTelegram,
    meta: { middleware: [auth] },
  },

  // =========================
  // 📄 Páginas legales + contacto (públicas)
  // =========================
  {
    path: "/aviso-legal",
    name: "AvisoLegal",
    component: () => import("@/views/legal/AvisoLegal.vue"),
    meta: { public: true },
  },
  {
    path: "/politica-privacidad",
    name: "PoliticaPrivacidad",
    component: () => import("@/views/legal/PoliticaPrivacidad.vue"),
    meta: { public: true },
  },
  {
    path: "/politica-cookies",
    name: "PoliticaCookies",
    component: () => import("@/views/legal/PoliticaCookies.vue"),
    meta: { public: true },
  },
  {
    path: "/contacto",
    name: "Contacto",
    component: () => import("@/views/Contacto.vue"),
    meta: { public: true },
  },

  // Pasarelas (privado)
  {
    path: "/pasarelas",
    name: "Pasarelas",
    component: Pasarelas,
    meta: { middleware: [auth] },
  },

  // Comisiones
  {
    path: "/comisiones",
    name: "Comisiones",
    component: () => import("@/views/Comisiones.vue"),
    meta: { middleware: [auth] },
  },

  // Registro de Movimientos
  {
    path: "/movimientos",
    name: "RegistroMovimientos",
    component: () => import("@/views/RegistroMovimientos.vue"),
    meta: { middleware: [auth] },
  },

  // Informes — hub de selección
  {
    path: "/informes",
    name: "Informes",
    component: () => import("@/views/Informes.vue"),
    meta: { middleware: [auth] },
  },

  // Informe de pedidos (sub-vista del hub)
  {
    path: "/informes/pedidos",
    name: "InformePedidos",
    component: () => import("@/views/InformePedidos.vue"),
    meta: { middleware: [auth] },
  },

  // Informe de ventas totales
  {
    path: "/informes/ventas",
    name: "InformeVentas",
    component: () => import("@/views/InformeVentas.vue"),
    meta: { middleware: [auth] },
  },

  // Métricas de negocio (solo admin, accesible desde hub de Informes)
  {
    path: "/metricas-negocio",
    name: "MetricasNegocio",
    component: () => import("@/views/MetricasNegocio.vue"),
    meta: { middleware: [auth] },
  },

  // Solicitudes de Tipster
  {
    path: "/solicitudes-tipster",
    name: "SolicitudesTipster",
    component: () => import("@/views/SolicitudesTipster.vue"),
    meta: { middleware: [auth] },
  },
  {
    path: "/landing-servicios",
    name: "LandingServicios",
    component: () => import("@/views/LandingServicios.vue"),
    meta: { middleware: [auth] },
  },

  // Pasarela pública
  {
    path: "/pay/:slug",
    name: "PasarelaPublica",
    component: PasarelaPublica,
    meta: { public: true },
  },

  // Verificación de email
  {
    path: "/verificar-email/:token",
    name: "VerificarEmail",
    component: () => import("@/views/VerificarEmail.vue"),
    props: true,
    meta: { public: true },
  },

  {
    path: "/:tipsterSlug/:productoSlug",
    name: "ResolverEnlaceCorto",
    component: ResolverEnlace,
    props: true,
  },

  { path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("@/views/NotFound.vue") },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",

  // ✅ Importante: hash + scroll suave (para #navegadores, etc.)
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: "smooth" };
    return { top: 0, behavior: "smooth" };
  },
});

// eslint-disable-next-line no-unused-vars
router.beforeEach(async (to, from, next) => {
  const context = { to, from, next, store };
  const middleware = to.meta.middleware;

  // ✅ Si es pública, no la toques con lógica de permisos/roles
  if (to.meta && to.meta.public) {
    return next();
  }

  const loggedIn = store.getters["auth/loggedIn"];
  // =========================================================
  // 🔄 Si hay sesión pero faltan permisos en store, intenta cargarlos
  // =========================================================
  if (loggedIn && !store.state.auth.me && !store.state.auth.meLoading) {
    try {
      await store.dispatch("auth/cargarMeYPermisos");
    } catch (error) {
      console.error("No se pudieron cargar permisos en router.beforeEach:", error);
    }
  }
  const rol = Number(
    store.state.auth?.me?.data?.attributes?.rol_efectivo ??
    store.state.auth?.me?.data?.data?.attributes?.rol_efectivo ??
    localStorage.getItem("usuarioRolId") ??
    0
  );
  const panelPorRol = () => {
    if (rol === 4) return { name: "PanelTipster" };
    if (rol === 5) return { name: "PanelPublicista" };
    if (rol === 3) return { name: "PanelCliente" };
    return { name: "Dashboard" };
  };

  // =========================================================
  // 🧭 HOME/DASHBOARD dinámico por rol
  // =========================================================
  if (loggedIn && (to.name === "HomeRedirect" || to.path === "/home" || to.path === "/")) {
    return next(panelPorRol());
  }

  // Tipster/Publicista NO pisan Dashboard general
  if (loggedIn && (to.name === "Dashboard" || to.path === "/dashboard") && (rol === 4 || rol === 5 || rol === 3)) {
    return next(panelPorRol());
  }

    // 🔒 Bloqueo por permisos
    const permisosStore = Array.isArray(store.state.auth?.permisos_finales)
      ? store.state.auth.permisos_finales
      : [];

    const permisosLocal = (() => {
      try {
        const raw = localStorage.getItem("permisos_finales");
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    })();

    const permisos = permisosStore.length > 0 ? permisosStore : permisosLocal;
    const permisosListos = permisos.length > 0;
  const can = (perm) => permisos.includes(perm);

  // ✅ Paneles: si es su rol, deja pasar aunque permisos todavía estén vacíos
  if (to.name === "PanelPublicista") {
    if (rol === 5) return next();
    if (permisosListos && !can("panel_publicista.ver")) return next(panelPorRol());
  }

  if (to.name === "PanelTipster") {
    if (rol === 4) return next();
    if (permisosListos && !can("panel_tipster.ver")) return next(panelPorRol());
  }
  if (to.name === "SuscripcionesListaTipster") {
    if (rol === 4) return next();
    if (permisosListos && !can("panel_tipster.ver") && !can("tipster.suscripciones.ver")) return next(panelPorRol());
  }
  if (to.name === "PanelCliente") {
    if (rol === 3) return next(); 
    if (permisosListos && !can("cliente.dashboard.ver")) return next(panelPorRol());
  }

  // Rutas sensibles por permiso (solo cuando permisos ya están listos)
  if (to.name === "Devoluciones" && permisosListos && !can("devoluciones.ver")) {
    return next(panelPorRol());
  }
  if (to.name === "AsignacionTipsters" && permisosListos && !can("asignacion_tipsters.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "Descuentos" && permisosListos && !can("descuentos.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "AnalyticsParticipantes" && permisosListos && !can("analytics.participantes.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "AnalisisVentas" && permisosListos && !can("analytics.ventas.ver")) {
    return next(panelPorRol());
  }
  if (to.name === "Roles" && permisosListos && !can("roles.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "Pasarelas" && permisosListos && !can("pasarelas.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "GrupoTelegram" && permisosListos && !can("canales.ver")) {
    return next(panelPorRol());
  }
    if (to.name === "Productos") {
    if (permisosListos && !can("productos.ver")) {
      return next(panelPorRol());
    }
  }

  if (to.name === "PaisesVenta") {
    if (permisosListos && !can("configuracion.ver")) {
      return next(panelPorRol());
    }
  }

  if (to.name === "Configuracion") {
    if (permisosListos && !can("configuracion.ver")) {
      return next(panelPorRol());
    }
  }

  if (to.name === "Pedidos" && permisosListos && !can("pedidos.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "Usuarios" && permisosListos && !can("usuarios.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "Tipsters" && permisosListos && !can("tipsters.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "Canales" && permisosListos && !can("canales.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "Campanas" && permisosListos && !can("campanas.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "CampanasServicios" && permisosListos && !can("producto_landings.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "PublicidadMeta" && permisosListos && !can("campanas.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "Comisiones" && permisosListos && !can("comisiones.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "RegistroMovimientos" && permisosListos && !can("movimientos.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "Informes" && permisosListos && !can("informes.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "InformePedidos" && permisosListos && !can("informes.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "InformeVentas" && permisosListos && !can("informes.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "MetricasNegocio" && ![1, 2].includes(rol)) {
    return next(panelPorRol());
  }

  if (to.name === "LandingServicios" && permisosListos && !can("producto_landings.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "SolicitudesTipster" && permisosListos && !can("solicitudes_tipster.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "PersonalizacionTipster" && permisosListos && !can("personalizacion_tipster.ver")) {
    return next(panelPorRol());
  }

  if (to.name === "CampanasTipster" && permisosListos && !can("tipster.campanas.ver")) {
    return next(panelPorRol());
  }

  // =========================================================
  // Middleware pipeline normal
  // =========================================================
  if (!middleware || middleware.length === 0) return next();

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

// page_view en cada navegación
router.afterEach((to) => {
  try {
    const title = to.meta?.title || to.name || to.path;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path:  to.fullPath,
        page_title: title,
      });
    } else if (window.dataLayer) {
      window.dataLayer.push({ event: 'page_view', page_path: to.fullPath, page_title: title });
    }
    if (typeof window.fbq === 'function') window.fbq('track', 'PageView');
  } catch (e) { /* analytics no disponibles */ }
});

export default router;
